<template>
    <div class="ask-question-box">
        <el-button @click="dialogFormVisible = true" class="btn theme-btn" :class="btnClass" size="large">
            {{btn ? btn : 'Ask Question'}}  <el-icon v-if="showIcon" class="icon"><ArrowRight /></el-icon>
        </el-button>
        <el-dialog v-model="dialogFormVisible" title="Ask Question">
            <el-form label-position="top">
                <el-form-item label="Title" required>
                    <el-input size="large" />
                </el-form-item>
                <el-form-item label="Body" required>
                    <tinymce :id="id ? id : 'd1'" v-model="bodyContent"></tinymce>
                </el-form-item>
                <el-form-item label="Tags">
                    <el-input size="large" v-model="qTag" @keyup="addTags" placeholder="e.g add tags by using comma" />
                    <div class="question-tags" v-if="tags.length">
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            content="Click to remove"
                            placement="top"
                            v-for="(tag, i) in tags" :key="i"
                        >
                            <span @click="deleteTag(tag)" >
                                {{tag}}
                            </span>
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="mt-3 btn theme-btn">Submit Question</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>


<script>
import tinymce from 'vue-tinymce-editor'
import {ArrowRight} from '@element-plus/icons-vue';

export default {
    name: 'AskQuestion',
    props: ['btnClass', 'btn', 'showIcon', 'id'],
    components: {
        tinymce,
        ArrowRight
    },
    data() {
        return {
            dialogFormVisible: false,
            bodyContent: 'Start write here',
            tags: [],
            qTag: ''
        }
    },
    methods: {
        addTags(e) {
            if (e.key === "," && this.qTag) {
                if (!this.tags.includes(this.qTag)) {
                    const tag = this.qTag.replace(',','');
                    
                    this.tags.push(tag);
                }
                this.qTag = "";
                console.log(this.tags);
            }
        },
        deleteTag(tag) {
            this.tags = this.tags.filter((item) => {
                return tag !== item;
            });
        },
    }
}
</script>